exports.f = Object.getOwnPropertySymbols;


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/_object-gops.js
 ** module id = 210
 ** module chunks = 0
 **/